import { render, staticRenderFns } from "./RTBDiscound.vue?vue&type=template&id=2900fe89"
import script from "./RTBDiscound.vue?vue&type=script&lang=js"
export * from "./RTBDiscound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports